<template>
  <v-flex
    md10
    :xs12="!isDesktop"
  >
    <v-item-group
      :key="weeksFromCurrent"
      v-model="form.values.date"
      @change="$emit('updateVisitTimes')"
    >
      <v-item
        v-for="weekDate of range"
        :key="weekDate"
        :value="weekDate"
      >
        <v-btn
          slot-scope="{ active, toggle }"
          outline
          :fab="isDesktop"
          :round="!isDesktop"
          :block="!isDesktop"
          :color="active ? 'primary' : 'grey darken-1'"
          :class="active && 'active-btn'"
          :disabled="isBeforeCurrentDate(weekDate)"
          @click="weekDate !== form.values.date && toggle()"
        >
          {{ getDate(weekDate).format('DD.MM') }}
        </v-btn>
      </v-item>
    </v-item-group>
  </v-flex>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateList',
  props: {
    weeksFromCurrent: {
      type: Number,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      default: undefined,
    },
    form: {
      type: Object,
      required: true,
    },
    range: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getDate(date) {
      return moment(date, 'YYYY-MM-DD')
    },
    isBeforeCurrentDate(checkedDate) {
      const now = moment().endOf('day')
      return moment(this.getDate(checkedDate)).isBefore(now.format('YYYY-MM-DD'))
    },
  },
}
</script>

<style scoped>
.active-btn {
    box-shadow: 0 0 10px var(--v-primary-base);
  }
</style>
